import React, {useRef, useState, useEffect} from 'react';
import { BASE_API } from '../../api/Globals';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { helpHttp } from "../../helpers/helpHttp";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { storage } from '../../helpers/storage';

import Menu from '../../components/sturtural/Menu';

const initialForm = {
    tienda: ""
}

const validationsFrom = (form) => {
    let errors = {};

    if(!form.tienda.trim()) {
        errors.tienda = "El Campo (Tienda) es requerido";
    } 
   
    return errors;
}

const CreateTienda = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);

    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);
    

    const perfil =  storage.get('perfilid');

    useEffect(() => {
        if(![1, 5, 9, 10, 11, 12].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    const toast = useRef(null);

    const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validationsFrom(form));
	};

    const showToast = (severity, summary, detail ) => {
        toast.current.show({ 
            severity: severity, 
            summary: summary, 
            detail: detail, 
            life: 5000 
        });
    };

    const handleSubmit = (e) => {
		e.preventDefault();
  
        setErrors(validationsFrom(form));

        if (Object.keys(errors).length === 0) {

            const arrUser = {
                opcion: "A",
                IdTienda: 0,
                Tienda: form.tienda,
                Activo: true
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}Usuarios/Ejecutartiendas`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
                })
                .then((res) => {
                    if(res.SUCCESS === true) {
                        showToast('success', 'Mensaje:', 'Tienda registrada correctamente');
                        return navigate('/configuracion/tiendas');
                    } else {
                        setMessage('(Error: 030) Error de conexión, Favor de iniciar el proceso nuevamente');
                        setAviso(true);
                    }
                });
        } else {
            showToast('warn', 'Aviso:', 'Favor de llenar los campos requeridos.');
            return;
        }
	};

    const handlerRedirect = () => {
        setMessage(null);
        setAviso(false)
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <div className="grid">
                <Toast ref={toast} />

                <Menu link='filtro' />
                
                <form onSubmit={handleSubmit} className="col-12">
                    <div className="card">
                        <div className="card-title">
                            <h4>Nueva Tienda</h4>
                        </div>

                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="usuario">Tienda:</label>
                                <InputText id="tienda" name="tienda" type="text" value={form.tienda} onChange={handleChange} onBlur={handleBlur} className={errors.tienda && 'p-invalid'} autoFocus />
                                {errors.tienda && <small className="p-error">{errors.tienda}</small>}
                            </div>
                        </div>
                        <div className="p-dialog-footer text-right" style={{marginTop: '15px', paddingTop: '15px'}}>
                            <Button label="Regresar" type="button" className="p-button-outlined p-button-secondary mr-2 mb-2" onClick={ () => navigate('/configuracion/tiendas')}/>
                            <Button label="Guardar" type="submit" className="p-button-raised p-button-danger mr-2 mb-2" />
                        </div>
                    </div>   
                </form>
            </div>

            <Dialog header="Aviso" visible={aviso} onHide={() => handlerRedirect} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
            
    )
}

export default CreateTienda;